module.exports = __webpack_public_path__ + "static/img/login_bg.2a38b24f.png";